import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { VOID } from '@frontend-site/shared/utils';
import { Observable } from 'rxjs';
import { ReleaseService } from './release.service';

@Injectable({ providedIn: 'root' })
export class ReleaseNameResolver  {
    constructor(private service: ReleaseService) {}

    resolve(route: ActivatedRouteSnapshot): Observable<void> {
        const { id, companyId } = route.params;

        this.service.getReleaseName(id, companyId).subscribe();
        return VOID;
    }
}
